import { render } from "./OffersCard.vue?vue&type=template&id=ac645c6e&scoped=true"
import script from "./OffersCard.vue?vue&type=script&lang=js"
export * from "./OffersCard.vue?vue&type=script&lang=js"

import "./OffersCard.vue?vue&type=style&index=0&id=ac645c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac645c6e"]])

export default __exports__